import type { FC } from 'react';

import type { IconProps } from './BaseIcon';
import { BaseIcon } from './BaseIcon';

export const GoogleDriveIcon: FC<IconProps> = ({
  preserveColor = false,
  ...props
}) => (
  <BaseIcon {...props} customFill={preserveColor}>
    <g clipPath="url(#gdrive-a)">
      <path
        fill="#0066DA"
        d="m5.814 22.998 1.059 1.79c.22.377.536.674.907.889l3.78-6.408H4c0 .418.11.835.33 1.212l1.484 2.517Z"
      />
      <path
        fill="#00AC47"
        d="m16 11.73-3.78-6.407a2.471 2.471 0 0 0-.907.889L4.33 18.058A2.4 2.4 0 0 0 4 19.269h7.56L16 11.731Z"
      />
      <path
        fill="#EA4335"
        d="M24.22 25.677a2.47 2.47 0 0 0 .907-.889l.44-.74 2.103-3.567a2.4 2.4 0 0 0 .33-1.212h-7.56l1.608 3.096 2.172 3.312Z"
      />
      <path
        fill="#00832D"
        d="m16 11.73 3.78-6.407A2.456 2.456 0 0 0 18.543 5h-5.086a2.6 2.6 0 0 0-1.237.323L16 11.731Z"
      />
      <path
        fill="#2684FC"
        d="M20.44 19.27h-8.88l-3.78 6.407c.371.215.798.323 1.237.323h13.966a2.6 2.6 0 0 0 1.237-.323l-3.78-6.408Z"
      />
      <path
        fill="#FFBA00"
        d="m24.179 12.135-3.492-5.923a2.471 2.471 0 0 0-.907-.889L16 11.731l4.44 7.538h7.546a2.4 2.4 0 0 0-.33-1.211l-3.477-5.923Z"
      />
    </g>
    <defs>
      <clipPath id="gdrive-a">
        <path fill="#fff" d="M4 5h24v21H4z" />
      </clipPath>
    </defs>
  </BaseIcon>
);
